import Image from "next/image";
import TestimonialData from "../../data/elements/testimonial.json";

const TestimonialSeven = () => {
  console.log("Testimoniql data", TestimonialData);
  return (
    <>
      {TestimonialData &&
        TestimonialData.testimonialOriginal.map((data, index) => (
          <div
            className="scroll-animation-wrapper no-overlay mt--20"
            key={index}
          >
            <div className="scroll-animation scroll-right-left">
              {data.left.map((item, innerIndex) => (
                <div
                  className="single-column-20 bg-theme-gradient-odd"
                  key={innerIndex}
                >
                  <div className="rbt-testimonial-box style-2">
                    <div className="inner" style={{ padding: "30px 25px" }}>
                      <div className="description">
                        <p className="subtitle-3">{item.desc}</p>
                        <div className="clint-info-wrapper">
                          <div
                            className="thumb"
                            style={{
                              width: "45px",
                              height: "45px",
                              borderRadius: "50%",
                              overflow: "hidden",
                              flexShrink: 0,
                            }}
                          >
                            <Image
                              src={
                                item.gender?.toLowerCase() === "female"
                                  ? "/images/instructor/instructor1.jpg"
                                  : "/images/instructor/instructor2.jpg"
                              }
                              width={45}
                              height={45}
                              alt="Client Image"
                              style={{
                                objectFit: "cover",
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <div className="client-info ms-3">
                            <h5 className="title m-0">
                              {item.title} <i>{item.position}</i>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

      {TestimonialData &&
        TestimonialData.testimonialOriginal.map((data, index) => (
          <div
            className="scroll-animation-wrapper no-overlay mt--20"
            key={index}
          >
            <div className="scroll-animation scroll-left-right">
              {data.right.map((item, innerIndex) => (
                <div
                  className="single-column-20 bg-theme-gradient-even"
                  key={innerIndex}
                >
                  <div className="rbt-testimonial-box style-2">
                    <div className="inner" style={{ padding: "30px 25px" }}>
                      <div className="description">
                        <p className="subtitle-3">{item.desc}</p>
                        <div className="clint-info-wrapper">
                          <div
                            className="thumb"
                            style={{
                              width: "45px",
                              height: "45px",
                              borderRadius: "50%",
                              overflow: "hidden",
                              flexShrink: 0,
                            }}
                          >
                            <Image
                              src={
                                item.gender?.toLowerCase() === "female"
                                  ? "/images/instructor/instructor1.jpg"
                                  : "/images/instructor/instructor2.jpg"
                              }
                              width={45}
                              height={45}
                              alt="Client Image"
                              style={{
                                objectFit: "cover",
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                              }}
                            />
                          </div>
                          <div className="client-info ms-3">
                            <h5 className="title m-0">
                              {item.title} <i>{item.position}</i>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </>
  );
};

export default TestimonialSeven;
